<template>
  <div>
    <v-menu offset-x nudge-left="6" content-class="portal-locale-sub-menu" v-if="children.length">
      <template v-slot:activator="{ on, attrs }">
        <button type="button" class="settings-link" v-bind="attrs" v-on="on">
          <span class="settings-icon" v-if="normalizedIcon">
            <portal-icon :size="17" :name="normalizedIcon"></portal-icon>
          </span>
          <span class="settings-label">{{label}}</span>
          <portal-icon name="chevron-right" :size="15" class="ml-auto"></portal-icon>
        </button>
      </template>
      <div class="locale-options">
        <button
            v-for="child in children"
            :key="child.code"
            type="button"
            class="locale-option"
            :class="{ 'is-selected': isCurrent(child.code) }"
            @click="$emit('selected', child.code)"
        >
          <span>{{ child.name }}</span>
          <portal-icon v-if="isCurrent(child.code)" name="check" :size="16"></portal-icon>
        </button>
      </div>
    </v-menu>

    <button type="button" class="settings-link" v-else @click="handleClick">
      <span class="settings-icon" v-if="normalizedIcon">
        <portal-icon :size="17" :name="normalizedIcon"></portal-icon>
      </span>
      <span class="settings-label">{{label}}</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "LocaleSwitcher",

  props: {
    pro: {type: Boolean, required: false, default: false},
    icon: { type: String, required: false},
    label: { type: String, required: true },
    route: { type: String, required: false },
    selectValue: {type: String, required: false},
    children: { type: Array, required: false, default: () => []},
  },

  components: {},

  data: function () {
    return {}
  },

  mounted() {
  },

  beforeDestroy() {
  },

  methods: {
    handleClick: function(){
      if(this.route){
        this.$router.push(this.route);
      }
      if(this.selectValue){
        this.$emit('selected',this.selectValue);
      }
    },

    isCurrent(code) {
      return String(this.$i18n.locale).toLowerCase() === String(code).toLowerCase();
    },
  },

  computed: {
    normalizedIcon() {
      return this.icon === 'translate' ? 'languages' : this.icon;
    },
  },

}
</script>

<style lang="scss">
.portal-locale-sub-menu {
  width: min(260px, calc(100vw - 24px));
  max-height: min(360px, calc(100vh - 32px));
  overflow-y: auto;
  padding: 6px;
  border: 1px solid var(--portal-border);
  border-radius: var(--brand-surface-radius, 14px) !important;
  background-color: var(--portal-surface);
  box-shadow: 0 16px 42px rgba(16, 17, 15, 0.18) !important;
}

.locale-options {
  display: grid;
  gap: 2px;
}

.locale-option {
  width: 100%;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 7px 10px;
  border: 0;
  border-radius: var(--brand-button-radius, 9px);
  background: transparent;
  color: var(--portal-text);
  font: inherit;
  font-size: 13px;
  text-align: left;
  cursor: pointer;
}

.locale-option:hover,
.locale-option.is-selected {
  background: var(--v-gray_20-base);
}

.locale-option:focus-visible {
  outline: 2px solid var(--v-primary-base);
  outline-offset: -2px;
}

.locale-option .portal-icon {
  color: var(--v-primary-base);
}
</style>

<style scoped lang="scss">
.settings-link {
  width: 100%;
  min-height: 44px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 9px;
  border: 0;
  border-radius: var(--brand-button-radius, 11px);
  background: transparent;
  color: var(--portal-text);
  font: inherit;
  font-size: 13px;
  font-weight: 560;
  line-height: 1.25;
  text-align: left;
  cursor: pointer;
}

.settings-link:hover {
  background: var(--v-gray_20-base);
}

.settings-link:focus-visible {
  outline: 2px solid var(--v-primary-base);
  outline-offset: -2px;
}

.settings-icon {
  width: 30px;
  height: 30px;
  flex: 0 0 30px;
  display: grid;
  place-items: center;
  border-radius: 9px;
  background: var(--v-gray_20-base);
  color: var(--portal-muted);
}

.settings-label {
  min-width: 0;
  flex: 1;
}
</style>
